<template>
  <div class="person">
    <app-loader v-if="loading" />
    <div
      v-else
      class="person__detail"
    >
      <section class="person__top">
        <!-- <section
        class="person__top"
        :style="{backgroundImage: getImgSrc}"
      > -->
        <div
          class="person__top-background"
          :style="{backgroundImage: getImgSrc}"
        />
        <v-container class="pt-2 pb-0 px-2 mb-0">
          <v-layout row>
            <v-breadcrumbs>
              <template v-slot:divider>
                <v-icon dark>
                  arrow_right
                </v-icon>
              </template>
              <v-breadcrumbs-item
                to="/"
                exact
                class="breadcrumbs"
              >
                Startseite
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                to="/personen"
                exact
                class="breadcrumbs"
              >
                Personen
              </v-breadcrumbs-item>
              <v-breadcrumbs-item disabled>
                {{ name }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
            <v-spacer />
            <v-btn
              small
              flat
              class="movie__back-btn white--text caption"
              @click="$router.go(-1)"
            >
              <v-icon
                left
                dark
                class="ma-0"
              >
                arrow_left
              </v-icon>Zurück
            </v-btn>
          </v-layout>
        </v-container>
        <v-container class="py-0">
          <div class="person__top-wrapper">
            <div
              v-if="!isMobile"
              class="person__picture"
            >
              <v-img
                class="person__img elevation-7"
                :src="profilePath ? `${posterPrefix}${profilePath}` : noPosterSrc"
                :lazy-src="gradient"
                :fade-transition="true"
              >
                <v-layout
                  slot="placeholder"
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular
                    indeterminate
                    :width="3"
                    color="red"
                  />
                </v-layout>
              </v-img>
            </div>
            <div class="person__top-content">
              <h1 class="person__name">
                {{ name }}
                <span
                  v-if="birthday"
                  class="person__year"
                >({{ parseAge(birthday) }})</span>
              </h1>
              <div class="person__actions">
                <v-tooltip bottom>
                  <v-btn
                    v-if="!isFavor"
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    :disabled="!checklogin"
                    color="blue-grey darken-1"
                    @click="addToFavor"
                  >
                    <v-icon>bookmark</v-icon>
                  </v-btn>

                  <v-btn
                    v-else
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    :disabled="!checklogin"
                    color="blue-grey darken-1"
                    @click="deleteFromFavor(getFavList.findIndex(el => el.id === id))"
                  >
                    <v-icon color="amber accent-4">
                      bookmark
                    </v-icon>
                  </v-btn>

                  <span v-if="checklogin && !isFavor">Zu meine Favoriten hinzufügen</span>
                  <span v-else-if="checklogin && isFavor">
                    Aussa mid dem Zeig aus meine Favoriten</span>
                  <span v-else>Meld di erst moi o!</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <app-carousel
                    slot="activator"
                    :images="profileImages"
                  />
                  <span v-if="profileImages.length !== 0">Weitere Bilder</span>
                  <span v-else>Gibd no koa buidl</span>
                </v-tooltip>
                <v-tooltip
                  v-if="facebookUrl"
                  bottom
                >
                  <v-btn
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    color="blue-grey darken-1"
                    @click="openNewTab(facebookUrl)"
                  >
                    <img
                      :src="facebookIcon"
                      class="person__icons"
                    >
                  </v-btn>

                  <span v-if="facebookUrl">{{ name }} auf Facebook</span>
                  <span v-else>Gibd no koa Facebook-Url</span>
                </v-tooltip>
                <v-tooltip
                  v-if="twitterUrl"
                  bottom
                >
                  <v-btn
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    color="blue-grey darken-1"
                    @click="openNewTab(twitterUrl)"
                  >
                    <img
                      :src="twitterIcon"
                      class="person__icons"
                    >
                  </v-btn>
                  <span v-if="twitterUrl">{{ name }} auf Twitter</span>
                  <span v-else>Gibd no koa Twitter-Url</span>
                </v-tooltip>
                <v-tooltip
                  v-if="instagramUrl"
                  bottom
                >
                  <v-btn
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    color="blue-grey darken-1"
                    @click="openNewTab(instagramUrl)"
                  >
                    <img
                      :src="instagramIcon"
                      class="person__icons"
                    >
                  </v-btn>
                  <span v-if="instagramUrl">{{ name }} auf Instagram</span>
                  <span v-else>Gibd no koa Instagram-Url</span>
                </v-tooltip>
              </div>

              <div class="person__items elevation-7">
                <h3 class="person__items-title">
                  Biografie
                </h3>
                <p class="person__items-biography">
                  {{ biography | readMore(1000, '...') }}
                </p>

                <app-details-modal
                  slot="activator"
                  :items="modalItems"
                />
              </div>
            </div>
          </div>
        </v-container>
      </section>
      <section class="person__bottom">
        <v-container>
          <h3 class="person__movies-title">
            Filme/Serien:
          </h3>
          <v-tabs
            centered
            dark
            color="teal"
            show-arrows
            icons-and-text
            class="elevation-7"
          >
            <v-tabs-slider color="yellow" />

            <v-tab
              v-if="groupedMovies && groupedMovies.length > 0"
              href="#tab-1"
            >
              Filme ({{ getMoviesLength }})
              <v-icon>local_movies</v-icon>
            </v-tab>
            <v-tab
              v-if="groupedTvShows && groupedTvShows.length > 0"
              href="#tab-2"
            >
              Serien ({{ getTVLength }})
              <v-icon>live_tv</v-icon>
            </v-tab>
            <v-tab
              v-if="groupedCrewJobs && groupedCrewJobs.length > 0"
              href="#tab-3"
            >
              Crew ({{ getCrewLength }})
              <v-icon>create</v-icon>
            </v-tab>

            <v-tab-item
              class="person__movie-tab"
              value="tab-1"
            >
              <v-card
                class="person__movie-card"
                flat
              >
                <v-container
                  v-for="(item, key, index) in groupedMovies"
                  :key="index"
                  fluid
                  grid-list-sm
                  class="person__tab-container"
                >
                  <v-subheader class="person__tab-subheader">
                    {{ item.year }}
                  </v-subheader>

                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      v-for="(movie, movieId) in item.movies"
                      :key="movieId"
                      xs6
                      sm3
                      md2
                      pa-2
                    >
                      <router-link
                        :to="'/film/' + movie.id"
                      >
                        <div class="person__movie-picture">
                          <v-lazy-image
                            class="person__movie-img elevation-7"
                            :src="movie.poster_path ?
                              `${imgPrefix}${movie.poster_path}` : noPosterSrc"
                            :src-placeholder="gradient"
                          />
                        </div>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>

            <v-tab-item
              class="person__movie-tab"
              value="tab-2"
            >
              <v-card
                class="person__movie-card"
                flat
              >
                <v-container
                  v-for="(item, key, index) in groupedTvShows"
                  :key="index"
                  fluid
                  grid-list-sm
                  class="person__tab-container"
                >
                  <v-subheader class="person__tab-subheader">
                    {{ item.genre }}
                  </v-subheader>
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      v-for="(tvShow, tvId) in item.tvShows"
                      :key="tvId"
                      xs4
                      sm2
                      pa-2
                    >
                      <router-link :to="'/serie/' + tvShow.id">
                        <div class="person__movie-picture">
                          <v-lazy-image
                            class="person__movie-img elevation-7"
                            :src="tvShow.poster_path ?
                              `${imgPrefix}${tvShow.poster_path}` : noPosterSrc"
                            :src-placeholder="gradient"
                          />
                        </div>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>

            <v-tab-item
              class="person__movie-tab"
              value="tab-3"
            >
              <v-card
                class="person__movie-card"
                flat
              >
                <v-container
                  v-for="(item, key, index) in groupedCrewJobs"
                  :key="index"
                  fluid
                  grid-list-sm
                  class="person__tab-container"
                >
                  <v-subheader class="person__tab-subheader">
                    {{ item.job }}
                  </v-subheader>
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      v-for="(crew, crewId) in item.crewJobs"
                      :key="crewId"
                      xs4
                      sm2
                      pa-2
                    >
                      <router-link
                        :to="crew.media_type === 'movie' ? '/film/' + crew.id
                          : '/serie/' + crew.id"
                      >
                        <div class="person__movie-picture">
                          <v-lazy-image
                            class="person__movie-img elevation-7"
                            :src="crew.poster_path ?
                              `${imgPrefix}${crew.poster_path}` : noPosterSrc"
                            :src-placeholder="gradient"
                          />
                        </div>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-container>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import _ from 'lodash';

import { base } from '../config/config';
import PersonCarousel from '../components/PersonCarousel.vue';
// import PersonCard from '../components/PersonCard.vue';
import PersonDetailsModal from '../components/PersonDetailsModal.vue';

const noBannerSrc = require('../assets/no-banner.jpg');
const noPosterSrc = require('../assets/noposter.jpg');
const noAvatarSrc = require('../assets/avatar.jpg');
const gradient = require('../assets/gradient.jpg');
const facebookIcon = require('../assets/facebook.1.svg');
const twitterIcon = require('../assets/twitter.1.svg');
const instagramIcon = require('../assets/instagram.1.svg');
const imdbIcon = require('../assets/imdb.svg');
const tmdbIcon = require('../assets/tmdb.1.svg');

const TIMEOUT = 1;

export default {
  name: 'Person',
  components: {
    appCarousel: PersonCarousel,
    appDetailsModal: PersonDetailsModal,
    // appPersonCard: PersonCard,
  },
  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    this.initPersonPage();
    next();
  },
  data() {
    return {
      id: '',
      lowImgPrefix: base.lowImgPrefix,
      imgPrefix: base.lowImgPrefix,
      posterPrefix: base.posterPrefix,
      profilePrefix: base.profilePrefix,
      noBannerSrc,
      noPosterSrc,
      noAvatarSrc,
      gradient,
      facebookIcon,
      twitterIcon,
      instagramIcon,
      imdbIcon,
      tmdbIcon,
      isMobile: false,
      name: '',
      knownFor: '',
      gender: '',
      birthday: '',
      deathday: '',
      placeOfBirth: '',
      biography: '', // TODO: english fallback language!
      popularity: '',
      profilePath: '',
      imdbId: '',
      homepage: '',
      credits: { cast: [], crew: [] },
      creditNames: ['Filme', 'Serien', 'Crew'],
      movies: [],
      groupedMovies: [],
      tvShows: [],
      groupedTvShows: [],
      crewCredits: [],
      groupedCrewJobs: [], // TODO: add crew job/department subheader
      profileImages: [],
      externalIds: {},
      facebookUrl: '',
      instagramUrl: '',
      twitterUrl: '',
      imdbUrl: '',
      tmdbUrl: '',
      backgroundImagePath: '',
    };
  },
  computed: {
    ...mapState({
      getFavList(state) {
        return state.favors.favors.people;
      },
    }),
    isFavor() {
      return this.getFavList.findIndex(el => el.id === this.id) !== -1;
    },
    loading() {
      return this.$store.getters.loading;
    },
    checklogin() {
      return this.$store.getters.login;
    },
    getImgSrc() {
      // return this.backgroundImagePath
      //   ? `linear-gradient(to bottom, rgba(77, 77, 77, 0.5), rgba(77, 77, 77, 0.3)), url("${
      //     this.posterPrefix
      //   }${this.backgroundImagePath}")`
      //   : `linear-gradient(to bottom, rgba(77, 77, 77, 0.5), rgba(77, 77, 77, 0.3)), url("${
      //     this.noBannerSrc
      //   }")`;
      return this.backgroundImagePath
        ? `url("${this.lowImgPrefix}${this.backgroundImagePath}")`
        : `url("${this.noBannerSrc}")`;
    },
    modalItems() {
      return this.getModalItems();
    },
    getMoviesLength() {
      let length = 0;
      if (this.groupedMovies) {
        if (this.groupedMovies.length > 0) {
          this.groupedMovies.forEach((element) => {
            length += element.movies.length;
          });
        }
      }
      return length;
    },
    getTVLength() {
      let length = 0;
      if (this.groupedTvShows) {
        if (this.groupedTvShows.length > 0) {
          this.groupedTvShows.forEach((element) => {
            length += element.tvShows.length;
          });
        }
      }
      return length;
    },
    getCrewLength() {
      let length = 0;
      if (this.groupedCrewJobs) {
        if (this.groupedCrewJobs.length > 0) {
          this.groupedCrewJobs.forEach((element) => {
            length += element.crewJobs.length;
          });
        }
      }
      return length;
    },

  },
  created() {
    this.initPersonPage();
    this.checkScreenWidth();
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT);
    }
  },
  methods: {
    checkScreenWidth() {
      if (window.innerWidth <= 600) {
        this.isMobile = true;
      }
    },
    addToFavor() {
      const person = {
        type: 'person',
        id: this.id,
        profile_path: this.profilePath,
        name: this.name,
        age: this.parseAge(this.birthday),
        known_for: [this.credits.cast[0], this.credits.cast[1], this.credits.cast[2]],
      };
      this.$store.dispatch('addToFavorList', person);
    },
    deleteFromFavor(index) {
      const id = this.getFavList[index].fbId;
      this.$store.dispatch('deleteFromFavorList', { id, title: this.name });
    },
    getModalItems() {
      const items = {
        knownFor: this.knownFor ? this.knownFor : '',
        gender: this.gender ? this.gender : '',
        birthday: this.birthday ? this.parseLocalDate(this.birthday) : '',
        placeOfBirth: this.placeOfBirth ? this.placeOfBirth : '',
        deathday: this.deathday ? this.parseLocalDate(this.deathday) : '',
        homepage: this.homepage ? this.homepage : '',
        movieCredits: this.movies.length > 0 ? this.movies.length : null,
        tvCredits: this.tvShows.length > 0 ? this.tvShows.length : null,
        crewCredits: this.crewCredits.length > 0 ? this.crewCredits.length : null,
        biography: this.biography ? this.biography : 'Kein Biografie vorhanden...',
      };

      return items;
    },
    parseLocalDate(date) {
      return new Date(date).toLocaleDateString();
    },
    parseYear(date) {
      if (date) {
        return new Date(date).getFullYear();
      }
      return '';
    },
    parseAge(date) {
      const birthday = new Date(date);
      const bdSeconds = birthday.getTime();
      const todaySeconds = new Date().getTime();
      const ageInSeconds = todaySeconds - bdSeconds;
      const yearInMs = 365.25 * 24 * 60 * 60 * 1000;
      return Math.floor(ageInSeconds / yearInMs);
    },
    parseBackgroundImage() {
      if (!this.backgroundImagePath) {
        if (this.movies.length > 0) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.movies.length; i++) {
            const movie = this.movies[i];
            if (movie.backdrop_path) {
              this.backgroundImagePath = movie.backdrop_path;
              break;
            }
          }
        } else if (this.tvShows.length > 0) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.tvShows.length; i++) {
            const tvShow = this.tvShows[i];
            if (tvShow.backdrop_path) {
              this.backgroundImagePath = tvShow.backdrop_path;
              break;
            }
          }
        }
      }
    },
    parceExternalUrls() {
      if (this.externalIds) {
        if (this.externalIds.facebook_id) {
          this.facebookUrl = `https://www.facebook.com/${
            this.externalIds.facebook_id
          }`;
        }
        if (this.externalIds.instagram_id) {
          this.instagramUrl = `https://instagram.com/${
            this.externalIds.instagram_id
          }`;
        }
        if (this.externalIds.twitter_id) {
          this.twitterUrl = `https://twitter.com/${
            this.externalIds.twitter_id
          }`;
        }
        if (this.externalIds.imdb_id) {
          this.imdbUrl = `https://www.imdb.com/name/${
            this.externalIds.imdb_id
          }`;
        }
      }
      this.tmdbUrl = `https://www.themoviedb.org/person/${this.id}`;
    },
    parceCredits() {
      const movies = [];
      const tvShows = [];
      const crew = [];
      if (this.credits) {
        if (this.credits.cast) {
          if (this.credits.cast.length > 0) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.credits.cast.length; i++) {
              const credit = this.credits.cast[i];

              if (credit.media_type === 'movie') {
                if (credit.release_date && credit.poster_path) {
                  credit.year = this.parseYear(credit.release_date);
                  movies.push(credit);
                }
              } else if (credit.media_type === 'tv') {
                if (credit.poster_path) {
                  if (credit.genre_ids.length > 0) {
                    if (credit.genre_ids.includes(10763)
                        || credit.genre_ids.includes(10764)
                        || credit.genre_ids.includes(10767)
                        || credit.genre_ids.includes(99)) {
                      credit.genre = 'Auftritte in Talkshows/Dokus';
                    } else {
                      credit.genre = 'Serien';
                    }
                  } else {
                    credit.genre = 'Auftritte in Talkshows/Dokus';
                  }
                  // credit.year = this.parseYear(credit.first_air_date);
                  tvShows.push(credit);
                }
              }
            }
          }
        }
        // TODO: remove duplicates
        this.movies = [...new Set(movies)];
        // console.log('movies:', this.movies);

        this.tvShows = [...new Set(tvShows)];
        // console.log('serien:', this.tvShows);


        // group and sort movies per year
        this.groupedMovies = this.groupMovies(this.movies);
        console.log(this.groupedMovies);

        // group and sort tvshows per year
        // TODO: serien nach "wirklichen" Serien und Gastauftritten in shows filtern!
        this.groupedTvShows = this.groupTVShows(this.tvShows);
        // console.log('groupedTvShows:', this.groupedTvShows);


        if (this.credits.crew) {
          if (this.credits.crew.length > 0) {
            this.credits.crew.forEach((credit) => {
              // TODO: credits nach filme/serien sortieren
              // if (element.) {

              // }
              if (credit.poster_path) {
                crew.push(credit);
              }
            });
          }
        }
        // TODO: handle crew credits?! -> departement/job
        // remove duplicates
        this.crewCredits = crew;

        this.groupedCrewJobs = this.groupCrewJobs(this.crewCredits);
        // console.log('crewJobs:', this.groupedCrewJobs);
      }
    },
    sortCredits(credits, dateStrings, order) {
      let elements = [];
      elements = _.orderBy(credits, dateStrings, order);
      // remove duplicates with a set (es6)
      return [...new Set(elements)];
    },
    groupMovies(credits) {
      const sorted = _
        .chain(credits)
        .uniqBy('id')
        .groupBy('year')
        .map((value, key) => ({
          year: key,
          movies: value,
        }))
        .reverse()
        .value();
      return sorted;
    },
    groupTVShows(credits) {
      const sorted = _
        .chain(credits)
        .uniqBy('id')
        .groupBy('genre')
        .map((value, key) => ({
          genre: key,
          tvShows: value,
        }))
        .orderBy('genre', 'desc')
        .value();
      return sorted;
    },
    groupCrewJobs(credits) {
      const sorted = _
        .chain(credits)
        .groupBy('job')
        .map((value, key) => ({
          job: key,
          crewJobs: value,
        }))
        .value();
      return sorted;
    },
    parceMovieYears() {
      // TODO: parceMovieYears löschen!
      const years = [];
      if (this.movies && this.movies.length > 0) {
        this.movies.forEach((movie) => {
          if (movie.release_date !== '') {
            years.push(this.parseYear(movie.release_date));
          } else {
            years.push(movie.release_date);
          }
        });
      }
      // remove duplicates -> creating a set
      this.movieYears = [...new Set(years)];
      // console.log('movieYears?:', this.movieYears);
    },
    openNewTab(url) {
      window.open(url, '_blank');
    },
    scrollTo(hashtag) {
      // TODO: scrollTo löschen?
      // eslint-disable-next-line no-restricted-globals
      setTimeout(() => { location.href = hashtag; }, TIMEOUT);
    },
    // showDetailsModal() {
    //   this.$store.commit('openDetailsModal');
    // },
    async getDetails() {
      // TODO: person details evtl. doch getrennt abfragen -> details zu serien/gastauftritten? usw...
      // getrennte animationen?
      try {
        const res = await axios.get(
          `${base.urlPrefix}/person/${this.id}?api_key=${base.key}&${
            base.language
          }&append_to_response=combined_credits,external_ids,images,tagged_images`,
        );

        const { data } = res;
        // console.log('Response data: ', data);

        this.id = data.id;
        this.name = data.name;
        this.gender = data.gender;


        if (data.known_for_department) {
          if (data.known_for_department === 'Acting') {
            if (this.gender === 1) {
              this.knownFor = 'Schauspielerin';
            } else if (this.gender === 2) {
              this.knownFor = 'Schauspieler';
            }
          } else {
            this.knownFor = data.known_for_department;
          }
        }

        this.birthday = data.birthday ? data.birthday : '';
        this.deathday = data.deathday ? data.deathday : '';
        this.placeOfBirth = data.place_of_birth ? data.place_of_birth : '';
        this.biography = data.biography ? data.biography : '';
        this.popularity = data.popularity ? data.popularity : '';
        this.profilePath = data.profile_path ? data.profile_path : '';
        this.imdbId = data.imdb_id ? data.imdb_id : '';
        this.homepage = data.homepage ? data.homepage : '';
        this.credits = data.combined_credits ? data.combined_credits : null;

        this.profileImages = data.images.profiles ? data.images.profiles : [];
        this.externalIds = data.external_ids ? data.external_ids : {};

        this.backgroundImagePath = data.tagged_images.results.length > 0
          ? data.tagged_images.results[0].media.backdrop_path
          : '';
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getFallbackDetails() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/person/${this.id}?api_key=${
            base.key
          }&language=en-US`,
        );
        const { data } = res;
        // console.log("Fetching englisch biography...");

        if (data.biography) {
          this.biography = data.biography;
        } else {
          this.biography = 'Nicht verfügbar im Moment...';
        }
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async initPersonPage() {
      this.$store.commit('clearError');
      this.$store.commit('setLoading', true);
      this.id = this.$route.params.id;
      await this.getDetails();

      if (!this.biography) {
        await this.getFallbackDetails();
      }

      this.parceExternalUrls();
      this.parceCredits();
      this.parseBackgroundImage();

      this.$store.commit('setLoading', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-lazy-image {
  display: block;
  width: 100%;
  filter: blur(5px);
  transition: filter 0.6s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
.person {
  position: relative;
  height: 100%;
  z-index: 0;

  &__top {
    position: relative;
    background-size: cover;
    background-position: top;
    height: 500px;

    @media (max-width: 1263px) {
      height: 400px;
    }

    @media (max-width: 768px) {
      height: 340px;
    }

    @media (max-width: 600px) {
      height: 300px;
    }
  }

  &__top-background {
    position: fixed;
    width: 100%;
    top: 20%;
    height: 350px;
    left: 0;
    filter: blur(25px);
    background-size: cover;
    z-index: -1;
  }

  &__top-wrapper {
    position: relative;
    display: flex;
  }

  &__picture {
    position: relative;
    min-width: 301px;
    max-height: 452px;
    // animation-delay: 0.5s;
    // bottom: 20px;
    // overflow: hidden;

    @media (max-width: 1263px) {
      min-width: 235px;
      max-height: 352px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  &__img {
    display: block;
    width: 100%;
  }

  &__breadcrumbs {
    a {
      color: #d1d1d1 !important;
    }
  }

  &__top-content {
    width: 100%;
    animation-delay: 0.5s;
    // margin-top: -20px;
    @media (max-width: 768px) {
      // margin-top: 0;
    }
  }

  &__name {
    margin-left: 30px;
    font-size: 1.6rem;
    font-weight: 500;

    @media (max-width: 768px) {
      font-weight: 500;
      font-size: 18px !important;
      margin-left: 0;
    }

    @media (max-width: 600px) {
      line-height: 18px !important;
      margin-bottom: 10px;
    }
  }
  &__year {
    // font-size: 20px;

    @media (max-width: 768px) {
      // font-size: 16px;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    padding-left: 30px;
    margin-top: 10px;
    // border-top: 1px solid #546e7a;
    // background-color: rgba(0, 0, 0, 0.4);

    @media (max-width: 768px) {
      // margin-top: 10px;
      padding: 0 20px;
    }

    @media (max-width: 425px) {
      display: flex;
      justify-content: space-between;
    }
  }

  &__icons {
    position: absolute;
    width: 40px;
  }

  &__items {
    padding: 10px 30px;
    margin-top: 10px;
    font-size: 14px;
    font-weight: 300;
    text-align: justify;
    border-top: 1px solid #546e7a;
    background-color: rgba(0, 0, 0, 0.4);

    @media (max-width: 960px) {
      padding: 10px 0 10px 50px;
      font-size: 14px;
    }

    @media (max-width: 768px) {
      padding: 10px 20px;
      font-size: 14px;
    }

    @media (max-width: 600px) {
      margin-top: 15px;
      font-size: 13px;
    }

    span {
      font-weight: 400;
    }
  }

  &__items-title {
    font-weight: 300;
    font-size: 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid #546e7a;
  }

  &__items-biography {
    margin-bottom: 0;
  }

  &__items-more-btn {
    left: 45%;
  }

  &__item {
    font-weight: 300;
    margin-bottom: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @media (max-width: 960px) {
      margin-bottom: 5px;
    }

    @media (max-width: 600px) {
      padding-left: 10px;
      margin-bottom: 4px;
    }
  }

  &__links {
    color: white;
    text-decoration: none;
  }

  &__bottom {
    animation-delay: 0s;
    animation-duration: 1.5s;
  }

  &__bottom-content {
    display: flex;

    @media (max-width: 1263px) {
      flex-direction: column;
    }
  }

  &__tab-container {
    padding: 0px 24px;
  }

  &__tab-subheader {
    padding: 0;
    padding-top: 10px;
    color: rgba(255,255,255,0.9);
    font-size: 1.1em;
    font-weight: normal;
  }

  &__bottom-left {
    width: 55%;
    padding-right: 20px;

    @media (max-width: 1263px) {
      width: 100%;
      margin-bottom: 30px;
      padding: 0;
    }

    @media (max-width: 600px) {
      margin-bottom: 10px;
    }
  }

  &__bottom-right {
    width: 45%;

    @media (max-width: 1263px) {
      width: 100%;
    }
  }

  &__images {
    display: flex;
    align-items: flex-end;
  }

  &__biography-title,
  &__movies-title,
  &__tv-title,
  &__crew-title {
    width: 100%;
    font-weight: 300;
    margin-bottom: 15px;
    font-size: 20px;
    border-bottom: 1px solid #546e7a;

    @media (max-width: 768px) {
      font-size: 18px;
    }

    @media (max-width: 600px) {
      margin-bottom: 10px;
    }
  }

  &__biography-text {
    font-size: 14px;
    font-weight: 300;
    text-align: justify;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  &__movie-img {
    transition: transform 0.25s ease-in-out;
    border-radius: 3px;
    // width: 100%;
    @media (min-width: 1264px) {
      height: 265px;
    }
    @media (max-width: 1263px) and (min-width: 960px) {
      height: 175px;
    }
    @media (max-width: 959px) {
      // height: 250px;
    }
    &:hover {
      @media (min-width: 960px) {
        transform: translateY(-5px);
      }
    }
  }
}
</style>
